import CommCodeModel from './CommCodeModel';

export default {
	CommCodeModel
};

export { CommCodeModel };
